import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaHome, FaWallet, FaUser, FaHistory } from "react-icons/fa";

const BottomNav = () => {
  const [activeTab, setActiveTab] = useState("home");
  const navigate = useNavigate();

  const navItems = [
    { id: "home", icon: FaHome, label: "Home", path: "/dashboard" },
    { id: "bets", icon: FaHistory, label: "My Bets", path: "/bet-history" },
    { id: "wallet", icon: FaWallet, label: "Wallet", path: "/wallet" },
    { id: "account", icon: FaUser, label: "Account", path: "/account" },
  ];

  const handleNavigation = (item) => {
    setActiveTab(item.id);
    navigate(item.path);
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50">
      <div className="bg-gray-900/90 backdrop-blur-lg border-t border-gray-800">
        <div className="flex justify-between px-4 py-2">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNavigation(item)}
              className="flex flex-col items-center justify-center w-16 py-2 group"
            >
              <item.icon
                className={`text-xl transition-all duration-200 ${
                  activeTab === item.id
                    ? "text-blue-500 drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]"
                    : "text-gray-400 group-hover:text-gray-200"
                }`}
              />
              <span
                className={`text-[10px] mt-1 transition-all duration-200 ${
                  activeTab === item.id
                    ? "text-blue-500"
                    : "text-gray-400 group-hover:text-gray-200"
                }`}
              >
                {item.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BottomNav;
